import PageDrawerMobile, { PageDrawerMobileRef } from "@/components/common/PageDrawerMobile"
import HotelSearchDestinationResult from "@/components/hotel/FormSearch/desktop/SelectPlacement/HotelSearchDestinationResult"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { hotelActions } from "@/lib/redux/features/hotel/reduce"
import { thunks } from "@/lib/redux/thunks"
import { Col, Input } from "antd"
import { forwardRef, useImperativeHandle, useRef, useState } from "react"
import { removeVietnameseChars } from "@/utils/string/removeVietnameseChars"
import { getSearchTypeLocationByValue } from "@/utils/hotel/getSearchTypeLocationByValue"
import { useTETranslation } from "@/hooks/app/useTETranslation"

export type DrawerSelectDestinationRef = PageDrawerMobileRef & {

}

type PageDrawerMobileProps = {}

const DrawerSelectDestination = forwardRef<DrawerSelectDestinationRef, PageDrawerMobileProps>(
  (props, ref) => {
    const refDrawer = useRef<PageDrawerMobileRef>(null)
    const dispatch = useAppDispatch()
    useImperativeHandle(ref, () => {
      return {
        open: () => refDrawer.current?.open(),
        close: () => refDrawer.current?.close(),
      }
    }, [])

    return (
      <PageDrawerMobile
        ref={refDrawer}
        className="page__drawer--hotel-destination"
        styles={{
          body: {
            background: "#ffffff",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            overflow: "hidden",
            padding: 0,
          },
          wrapper: {
            top: 0,
          },
          mask: {
            top: 0,
          },
        }}
        headerProps={{
          title: <SearchInput />,
        }}
      >
        <Col span={24} className="home__searching--destination-drawer">
          <HotelSearchDestinationResult
            onChange={(location: any) => {
              dispatch(hotelActions.selectDestination(location))
              refDrawer.current?.close()
            }}
          />
        </Col>
      </PageDrawerMobile>
    )
  })

const SearchInput = () => {
  const [searchValue, setSearchValue] = useState("")
  const refTimeoutSearch = useRef<any>(null)
  const dispatch = useAppDispatch()
  const searchingDestination = useAppSelector(state => state.hotel.searchingDestination)
  const location = useAppSelector(state => state.hotel.formSearch.location)
  const typeSearch = useAppSelector(state => state.hotel.typeSearch)
  const { getTranslatedText } = useTETranslation()

  return (
    <Input
      value={searchValue}
      onFocus={() => {
        dispatch(hotelActions.updateSearchingDate(false))
        dispatch(hotelActions.setPopularDestinations({
          show: typeSearch
        }))
      }}
      onChange={(e) => {
        const val = e.target.value
        if (refTimeoutSearch.current) {
          clearTimeout(refTimeoutSearch.current)
        }
        if (val) {
          refTimeoutSearch.current = setTimeout(() => {
            dispatch(thunks.hotels_locations_search({
              params: {
                searchTerm: removeVietnameseChars(val || ""),
                searchType: getSearchTypeLocationByValue(val || ""),
                limit: 50,
                offset: 0
              }
            }))
          }, 500)
        } else {
          dispatch(hotelActions.setPopularDestinations({
            show: typeSearch
          }))
        }
        setSearchValue(val)
        if (val && (val !== getTranslatedText(location?.nameLang?.vi, location?.nameLang?.en))) {
          if (!searchingDestination) {
            dispatch(hotelActions.updateSearchingDate(true))
          }
        } else {
          if (searchingDestination) {
            dispatch(hotelActions.updateSearchingDate(false))
          }
        }
      }}
      size='large'
      placeholder="Select..."
    />
  )
}

export default DrawerSelectDestination